/*
 * Public API Surface of unitx-angular-chatbot-component
 */

export * from './lib/unitx-angular-chatbot-component.service';
export * from './lib/unitx-angular-chatbot-component.component';
export * from './lib/unitx-angular-chatbot-component.module';
